/* eslint-disable max-lines-per-function */
import { Form, Formik, FormikConfig } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Grid } from "@material-ui/core";
import { navigate } from "@reach/router";
import { Button } from "components/haven-design/buttons";
import { InputWithErrorLabel } from "components/haven-design/form/inputs";
import { Card } from "components/haven-design/card";
import { HavenConnectLoginLogo, BackToLogin, LoneGrid, LoginCardTitle, PasswordValidations } from "components/login/components/shared-components";
import { PasswordValidationType, validatePassword } from "components/login/utils";
import { chooseNewPassword } from "./actions";
import { loginStyles } from "./styles";

interface Props {
  path: string;
  token?: string;
}

const ChoosePassword: React.FC<Props> = (props) => {
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<PasswordValidationType[]>([]);
  useEffect(() => {
    setErrors(validatePassword(password));
  }, [password]);

  const onSubmit: FormikConfig<{ password: string }>["onSubmit"] = async (values, handlers) => {
    await chooseNewPassword(props.token || "", values.password)
      .then((returnUrl: string) => {
        // root view will redirect to correct home page
        navigate(returnUrl || "/");
      })
      .catch((error: string) => handlers.setFieldError("password", `${error}`));
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={12}>
        <HavenConnectLoginLogo />
      </Grid>
      <Card>
        <LoneGrid>
          <LoginCardTitle title={<>&nbsp;&nbsp;Choose a new password&nbsp;&nbsp;</>} />
          <Formik
            initialValues={{ password }}
            onSubmit={onSubmit}
            validationSchema={yup.object().shape({
              password: yup.string().required().validPassword(),
            })}
            enableReinitialize={true}
          >
            <Form>
              <Grid item md={8} style={{ minWidth: "70%" }}>
                <InputWithErrorLabel
                  name="password"
                  label="New Password"
                  type="password"
                  style={loginStyles.loginInput}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Grid>
              <Grid item md={8}><PasswordValidations errors={errors} /></Grid>
              <Grid item md={12}><br/></Grid>
              <LoneGrid>
                <Button
                  disabled={errors.length > 0}
                  size="L" color="primary" type="submit" style={loginStyles.btn}
                >
                    Save and Log In
                </Button>
              </LoneGrid>

              <BackToLogin />
            </Form>
          </Formik>
        </LoneGrid>
      </Card>
    </Grid>
  );
};

export default ChoosePassword;
